function ScreeningQuestion({ question }: { question: string }) {
  return <p className="font-bold text-lg text-dark-text max-w-[320px]">{question}</p>;
}

export default ScreeningQuestion;
